import type { ComponentProps, ReactNode } from "react";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import { Fields } from "./Fields";

const basicFields = ["title", "description"];
const dateFields = ["startsAtEpochMillis", "endsAtEpochMillis"];

export function UnitDetailsFields({ children, datesLocked = false, ...props }: ComponentProps<typeof Fields> & { children?: ReactNode; datesLocked?: boolean }) {
  const { w } = useLocale();
  const properties = Object.entries(props.schema.properties || {}).filter(([key]) => !props.hidden?.includes(key));
  const fields = (keys: string[]) => <Fields {...props} showDateTimezone={false} schema={{
    ...props.schema,
    properties: Object.fromEntries(properties.filter(([key]) => keys.includes(key))),
  }} />;
  const additional = properties.map(([key]) => key).filter(key => !basicFields.includes(key) && !dateFields.includes(key));
  return <div className="event-details-sections">
    <section className="event-details-section">
      <div className="event-details-section-heading">
        <h4>{w("البيانات الأساسية", "Basic details")}</h4>
        <span className="event-details-required">{w("الحقول بعلامة * مطلوبة", "Fields marked * are required")}</span>
      </div>
      {fields(basicFields)}
    </section>
    <section className="event-details-section event-details-dates">
      <div className="event-details-section-heading">
        <h4><CalendarDaysIcon aria-hidden="true" />{w("المواعيد", "Schedule")}</h4>
        <span className="event-details-timezone">{w("الوقت المحلي", "Local time")} · <bdi>{Intl.DateTimeFormat().resolvedOptions().timeZone}</bdi></span>
      </div>
      <p className="event-details-schedule-help">{datesLocked ? w("ثُبّتت مواعيد الجولة بعد اعتمادها؛ يمكن تعديل الاسم والوصف دون تغيير المواعيد.", "The schedule is frozen after the round is made ready. You can edit its name and description without changing the dates.") : props.context.unit?.unitKind === "VOTING_ROUND"
          ? w("يمكن إكمالها لاحقاً في المسودة؛ يلزم تحديدها قبل نشر الجولة.", "You can complete these later in the draft. Both dates are required before publishing the round.")
          : w("اختيارية؛ يمكنك ترك المواعيد فارغة وإضافتها لاحقاً.", "Optional. You can leave these empty and add them later.")}</p>
      <fieldset disabled={datesLocked} style={{ border: 0, padding: 0, margin: 0 }}>{fields(dateFields)}</fieldset>
    </section>
    {children && <section className="event-details-section event-details-weight">
      <div className="event-details-section-heading">
        <h4>{w("وزن الجولة", "Round weight")}</h4>
        <p>{w("حدّد مساهمة هذه الجولة في نتيجة المرحلة.", "Set this round’s contribution to the stage result.")}</p>
      </div>
      <div>{children}</div>
    </section>}
    {additional.length > 0 && <div className="event-details-additional">{fields(additional)}</div>}
  </div>;
}
